<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Register',

  data () {
    return {
    }
  },

  methods: {}
}
</script>

<style lang='scss' scoped>

</style>
